module.exports = __webpack_public_path__ + "static/media/home_bg.11e71f0b.png";